export const MuiIconButton = {
  styleOverrides: {
    root: {
      borderRadius: '5px',
      '&.icon-button-base': {
        borderRadius: '5px',
        border: '0.5px solid rgba(27, 31, 36, 0.15)',
        backgroundColor: 'rgb(249, 249, 249)',
        color: 'text.main',
        '&:hover': {
          backgroundColor: 'rgb(243, 244, 246)',
        },
      },
      '&.no-border': {
        height: '18px',
        border: 'none',
        width: '18px',
        color: 'inherit',
        padding: '0',
      },
    },
    sizeSmall: {
      width: '24px',
      height: '24px',
    },
    sizeMedium: {
      width: '40px',
      height: '40px',
    },
    sizeLarge: {
      width: '50px',
      height: '50px',
    },
  },
}
